import PaginationDot from '../../atoms/icons/paginationDot';
import PagionationDotContainer from '../../atoms/container/paginationDotContainer';
import { StyledComponent } from 'styled-components';

interface Props {
  Container: StyledComponent<'div', any, React.CSSProperties, never>;
  length: number;
  index: number;
}

export default function PaginationDots({ Container, length, index }: Props) {
  return length > 1 ? (
    <Container id={'paginationDots'}>
      {[...Array(length)]?.map((_, i) => (
        <PagionationDotContainer key={i}>
          <PaginationDot focused={i === index} key={i} />
        </PagionationDotContainer>
      ))}
    </Container>
  ) : null;
}
